import React, { useEffect, useState } from 'react';
import _ from "lodash";

import { getNextQuestionAndIndex } from '../../../utils/surveyNavigation';
import { TextFieldComponent, RatingComponent, CheckboxComponent } from '..';
import { Box, Typography, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';


const RadioComponent = ({question, handleNext, handleAnswer, survey_answers, conditional, conditionalConfig, survey}) => {

    const [value, setValue] = useState('')
    const [options, setOptions] = useState([])
    const [activeStep, setActiveStep] = useState(false)
    const [showConditional, setShowConditional] = useState(false)
    const [activeConditionalConfig, setActiveConditionalConfig] = useState(null)
    const [answer_exists, setAnswerExists] = useState(false)

    // Use conditionalConfig if provided, otherwise use question
    const activeQuestion = conditional && conditionalConfig ? {
        ...question,
        number: conditionalConfig.number,
        question: conditionalConfig.response_question,
        type_config: conditionalConfig.type_config || question.type_config
    } : question;

    useEffect(() => {
        const typeConfig = activeQuestion.type_config || (conditionalConfig && conditionalConfig.type_config);
        setOptions(typeConfig?.radio_options ?? []);
        if (!activeStep) {
            setActiveStep(true);
        }
        if (survey_answers.length !== 0) {
            let answer;
            if (conditional && conditionalConfig) {
                answer = _.find(survey_answers, { question_number: conditionalConfig.number });
            } else {
                answer = _.find(survey_answers, { question_number: question.number });
            }
            if (answer) {
                setAnswerExists(true);
                setValue(answer.user_response);
            }
        }
    }, [activeQuestion.type_config, conditionalConfig, conditional, survey_answers, question.number]);
    
    useEffect(() => {
        let timeoutId;
        if (value.length !== 0 && !answer_exists) {
            timeoutId = setTimeout(async () => {
                const answer = {
                    question: activeQuestion.question,
                    question_number: activeQuestion.number,
                    question_type: activeQuestion.type || (conditional && conditionalConfig ? conditionalConfig.type : question.type),
                    user_response: value,
                };
                await handleAnswer(answer);

                // Only check for conditionals if this is not already a conditional question
                if (!conditional && question.conditional) {
                    // Handle conditional_config as array or single object; filter out null/undefined to avoid null refs
                    const rawConfigs = Array.isArray(question.conditional_config)
                        ? question.conditional_config
                        : [question.conditional_config];
                    const conditionalConfigs = rawConfigs.filter(Boolean);
                    // Match: exact condition, or (multi-word condition) value matches a space-separated token (e.g. "MTN Vodacom Cell C").
                    const matchingConfig = conditionalConfigs.find((config) => {
                        if (value === config.condition) return true;
                        if (typeof config.condition === 'string' && config.condition.includes(' ')) {
                            const tokens = config.condition.trim().split(/\s+/);
                            return tokens.includes(value);
                        }
                        return false;
                    });
                    if (matchingConfig) {
                        setActiveConditionalConfig(matchingConfig);
                        setShowConditional(true);
                    } else {
                        handleNext(question.next_question || null, question.next_question_index);
                    }
                } else {
                    const { nextQuestion, nextQuestionIndex } = getNextQuestionAndIndex({
                        question,
                        activeQuestion,
                        conditionalConfig,
                        conditional,
                        survey,
                    });
                    handleNext(nextQuestion, nextQuestionIndex);
                }
            }, 1000);
        }
        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [value, answer_exists, question, conditionalConfig, conditional, activeQuestion, survey, handleAnswer, handleNext]);

    const handleChange = (event) => {
      setValue(event.target.value);
      setAnswerExists(false)
    };

    return (
        <Box>
            {!showConditional ?
            <FormControl className={activeStep ? 'active' : 'inactive' }>
                <Typography variant="h1" sx={{fontFamily: 'Open Sans', fontWeight: 400, color: '#002846', textAlign: 'left', pb: 4}}>
                <Typography variant="body1" component={'span'} sx={{fontFamily: 'VAG Rounded', color: '#002846', textAlign: 'left'}}>{activeQuestion.number}. </Typography>
                    {activeQuestion.question}
                </Typography>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={handleChange}
                >
                    {options.map((option, index) => (
                        <FormControlLabel sx={{color: '#002846' }} key={index} value={option} control={<Radio sx={{color: '#002846','&.Mui-checked': {color: '#002846'}}} />} label={option} />
                    ))}
                </RadioGroup>
            </FormControl>
            :
            <Box className={activeStep ? 'active' : 'inactive' }>
                { activeConditionalConfig && activeConditionalConfig.type === 'textfield' && (
                    <TextFieldComponent conditional={true} question={question} conditionalConfig={activeConditionalConfig} handleNext={handleNext} handleAnswer={handleAnswer} survey_answers={survey_answers} survey={survey}/>
                )}
                { activeConditionalConfig && activeConditionalConfig.type === 'rating' && (
                    <RatingComponent conditional={true} question={question} conditionalConfig={activeConditionalConfig} handleNext={handleNext} handleAnswer={handleAnswer} survey_answers={survey_answers} survey={survey}/>
                )}
                { activeConditionalConfig && activeConditionalConfig.type === 'checkbox' && (
                    <CheckboxComponent conditional={true} question={question} conditionalConfig={activeConditionalConfig} handleNext={handleNext} handleAnswer={handleAnswer} survey_answers={survey_answers} survey={survey}/>
                )}
                { activeConditionalConfig && activeConditionalConfig.type === 'radio' && (
                    <RadioComponent conditional={true} question={question} conditionalConfig={activeConditionalConfig} handleNext={handleNext} handleAnswer={handleAnswer} survey_answers={survey_answers} survey={survey}/>
                )}
            </Box>
            }
        </Box>
    )
}
export default RadioComponent
